const SITE_URL = (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env && ((import.meta as Record<string, unknown>).env as Record<string, string>).VITE_SITE_URL) || 'https://gtbuyspreadsheet.living';
const SITE_IMAGE = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/54d75be42d5913aa14ca64dd22e5d1e3.jpeg';

interface WebSiteSchemaProps {
  name: string;
  description: string;
  url: string;
}

interface BlogPostingSchemaProps {
  headline: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified: string;
}

export function WebSiteSchema({ name, description, url }: WebSiteSchemaProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name,
    description,
    url,
    image: SITE_IMAGE,
    potentialAction: {
      '@type': 'SearchAction',
      'target': {
        '@type': 'EntryPoint',
        'urlTemplate': `${SITE_URL}/?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
    publisher: {
      '@type': 'Organization',
      name: 'GTBuy Hub Editorial',
      url: SITE_URL,
      logo: SITE_IMAGE,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export function BlogPostingSchema({
  headline,
  description,
  url,
  datePublished,
  dateModified,
}: BlogPostingSchemaProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline,
    description,
    url,
    datePublished,
    dateModified,
    author: {
      '@type': 'Organization',
      name: 'GTBuy Hub Editorial',
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: 'GTBuy Hub Editorial',
      url: SITE_URL,
      logo: SITE_IMAGE,
    },
    image: SITE_IMAGE,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    isAccessibleForFree: true,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}